import { Workspace } from '../../clients/aasServerClient.generated';
import * as actionCreators from './actionCreators';
import { ActionTypeNames } from './actions';

export interface State {
    table: Workspace[];
    all: Workspace[];
    singleWorkspace: {
        loaded: boolean;
        saved: boolean;
        workspace?: Partial<Workspace>;
    };
}

const initialState: State = {
    all: [],
    singleWorkspace: {
        loaded: false,
        saved: false,
        workspace: undefined,
    },
    table: [],
};

type Actions = ReturnType<typeof actionCreators[keyof typeof actionCreators]>;

export default function reducer(state: State = initialState, action: Actions): State {
    switch (action.type) {
        case ActionTypeNames.StoreTableWorkspaces:
            return {
                ...state,
                table: action.workspaces
            };
        case ActionTypeNames.StoreAllWorkspaces:
            return {
                ...state,
                all: action.workspaces,
            };
        case ActionTypeNames.ClearSingleWorkspace:
            return {
                ...state,
                singleWorkspace: {
                    loaded: false,
                    saved: false,
                    workspace: undefined,
                },
            };
        case ActionTypeNames.StoreSingleWorkspace:
            return {
                ...state,
                singleWorkspace: {
                    loaded: true,
                    saved: false,
                    workspace: action.workspace,
                },
            };
        case ActionTypeNames.SavedSingleWorkspace:
            return {
                ...state,
                singleWorkspace: {
                    ...state.singleWorkspace,
                    saved: true,
                }
            };
        default:
            return state;
    }
}
